import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'join'
})
export class JoinPipe implements PipeTransform {
  public transform(array: any[] | any, field: string = '', separator = ', '): string {
    if (!array) {
      return '';
    }
    const fields = field.split('.');
    if (Array.isArray(array)) {
      return array
        .map((item) =>
          fields.reduce((value, key) => {
            if (!key) return value;
            else return value[key] ?? 'Нет';
          }, item)
        )
        .join(separator);
    } else if (typeof array === 'object') {
      return Object.keys(array)
        .map(() =>
          fields.reduce((value, key) => {
            if (!key) return value;
            else return value[key] ?? 'Нет';
          }, array)
        )
        .join(separator);
    } else {
      return array;
    }
  }
}
